<template>
	<div>
		<div class="box-title2">{{ data.alt ? data.alt : data.label }}</div>
		<div class="tagbox">
			<div v-for="(tag,idx) in data.children"
				 :key="tag.id+'_'+idx"
				 :class="{'selected':tag.selected}"
				 @click="toggleItem(tag)"
				 class="chip"
			>{{ tag.label }}
			</div>
		</div>
	</div>
</template>
<script>
	import mixins from "@/components/Tags/mixins";

	export default {
		name: 'TagsExpanded',
		mixins: [ mixins ],
		props: {
			data: { type: Object, default() { return {} } },
		},
		//
		data() {
			return {
				tagBoxes: {}
			}
		},
		//
		created() {
			for (let k in this.data.children) {
				if (!this.data.children.hasOwnProperty(k)) continue;
				if (this.data.children[k].selected) {
					this.selectItem(this.data.children[k]);
				}
			}
		},
		//
		methods: {
			toggleItem(tag) {
				tag.selected = !tag.selected;
				if (this.isDir(tag)) {
					if (tag.selected) {
						this.tagBoxes[tag.id] = tag;
					} else {
						this.unselectAllChilds();
						this.resetAllChilds(tag.children);
					}
				}
			},
			unselectAllChilds() {
				for (let k in this.tagBoxes) {
					if (!this.tagBoxes.hasOwnProperty(k)) continue;
					this.tagBoxes[k].selected = false;
					delete this.tagBoxes[k];
				}
				for (let k in this.tagBoxesRelated) {
					if (!this.tagBoxesRelated.hasOwnProperty(k)) continue;
					this.tagBoxesRelated[k].selected = false;
					delete this.tagBoxesRelated[k];
				}
			},
			resetAllChilds(children) {
				if (!Array.isArray(children)) return;
				for (let k in children) {
					if (!children.hasOwnProperty(k)) continue;
					children[k].selected = false;
					if (Array.isArray(children[k].children)) {
						this.resetAllChilds(children[k].children);
					}
				}
			},
		},
		//
	}

</script>